// lot store inner constants

export const ACT_LOADFOLDERS = 'foldersLoad';

export const GET_FOLDERS = 'foldersGet';

export const MUT_FOLDERS = 'foldersAdd';
